import { render, staticRenderFns } from "./Georreferencer.vue?vue&type=template&id=3f39df1c&scoped=true&"
import script from "./Georreferencer.vue?vue&type=script&lang=js&"
export * from "./Georreferencer.vue?vue&type=script&lang=js&"
import style0 from "./Georreferencer.vue?vue&type=style&index=0&id=3f39df1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f39df1c",
  null
  
)

export default component.exports